import { useBlocosWorkdir } from '../hooks';

/**
 * Preview AO VIVO dos blocos durante a geração (#5). Lê o RASCUNHO_BLOCOS.json
 * que o claude_stream.py grava incrementalmente no workdir — os blocos vão
 * aparecendo conforme o Claude os escreve. Compacto; some quando não há blocos.
 */
export function BlocosLivePreview({ idPrazo, ativo }: { idPrazo: number; ativo: boolean }) {
  const { data } = useBlocosWorkdir(ativo ? idPrazo : null, ativo);
  const blocos = data?.blocos ?? [];
  if (!ativo || blocos.length === 0) return null;

  const ultimos = blocos.slice(-7);
  const ocultos = blocos.length - ultimos.length;

  function rotulo(b: any): { txt: string; topico: boolean } {
    if (b?.type === 'TOPICO') return { txt: `▸ ${b.titulo ?? 'Tópico'}`, topico: true };
    if (b?.type === 'ENDERECO') return { txt: b.text ?? 'Endereçamento', topico: false };
    if (b?.type === 'PEDIDO') return { txt: `• ${b.text ?? 'Pedido'}`, topico: false };
    if (b?.type === 'ASSINATURA') return { txt: '✍ Assinatura', topico: false };
    if (typeof b?.text === 'string') return { txt: b.text, topico: false };
    return { txt: b?.type ?? '…', topico: false };
  }

  return (
    <div className="mt-1.5 rounded-lg border border-blue-200/55 dark:border-blue-900/40 bg-blue-50/60 dark:bg-blue-950/20 p-2">
      <div className="text-[10px] font-semibold text-blue-700 dark:text-blue-300 mb-1 flex items-center gap-1">
        <span className="inline-block animate-pulse">✍</span>
        Rascunho ao vivo — {blocos.length} bloco(s)
      </div>
      <ul className="space-y-0.5 max-h-28 overflow-y-auto pr-1">
        {ocultos > 0 && (
          <li className="text-[10px] text-slate-400 dark:text-slate-500 italic">… +{ocultos} bloco(s) acima</li>
        )}
        {ultimos.map((b: any, i: number) => {
          const r = rotulo(b);
          return (
            <li key={i}
                className={`text-[11px] leading-tight truncate ${r.topico
                  ? 'font-semibold text-blue-800 dark:text-blue-200'
                  : 'text-slate-600 dark:text-slate-300'}`}
                title={r.txt}>
              {r.txt}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
